const lang = {
  position: {
    title: '箇所選択',
    button_select_all: '全て選択/解除',
    button_select: '選択',
    button_next: '次へ',
    button_delete: '削除',
    button_cancel: 'キャンセル',
    button_copy: 'コピー',
    appstore_title: '撮影写真がありません。『ZENGOカメラ』(アプリ)から撮影をしてください。',
    appstore_description: 'ZENGOカメラを<br>無料ダウンロード',
    appstore_note: '※AppStoreへ遷移します。'
  },
  detail: {
    title: '箇所一覧'
  },
  layout: {
    button_make_report: '報告書ダウンロード',
    button_preview_report: '報告書プレビュー',
    pick_layout: '報告書レイアウトを選択',
    modal_empty_construction_site_header: 'お知らせ',
    modal_empty_construction_site_content: '案件に写真が設定されていないため、このレイアウトは選択できません。</br></br>写真を設定してから再度お試しください。'
  },
  breadcrumb_home: 'ホーム',
  breadcrumb_project_list: '案件一覧',
  breadcrumb_create_report: '報告書生成',
  modal_open_pdf: {
    content: 'PDF作成が完了しました',
    button: 'プレビュー'
  },
  edit_construction_site: {
    title: '箇所編集',
    prev_comment: '前写真コメント',
    copy_comment: '後写真にコピー',
    prev_comment_placeholder: '前写真コメントを入力',
    next_comment_placeholder: '後写真コメントを入力',
    mid_comment_placeholder: '中写真コメントを入力',
    insert_shooting_date: '撮影日をコメントに挿入',
    later_comment: '後写真コメント',
    lastes_comment: '写真コメント',
    lastes_comment_placeholder: '写真コメントを入力',
    photo_library: 'フォトライブラリ',
    file_size_0_bite: '破損しているファイルが選択されています。別の写真を選択いただき、再度お試し下さい。',
    choose_jpg_jpeg: 'jpgまたはjpeg画像を選択してください。',
    modal_after_image_header: 'お知らせ',
    modal_after_image_content: '前写真がない状態で </br> 後写真を追加することはできません。</br></br>まずは前写真を追加しましょう。',
    remaining_comment: '残り{num}文字'
  },
  copy_construction_site: {
    modal_copy_title: '箇所コピー',
    copy_quantity: '件の箇所がコピーされます',
    label_construction_copy: '案件名（コピー先）',
    please_select: '選択してください',
    button_copy: 'コピーを作成',
    button_back: '戻る',
    modal_complete_title: '箇所コピー完了',
    modal_complete_body: '箇所をコピーしました。',
    go_to_construction_copy: 'コピー先の案件を開く',
    back_to_list: '箇所一覧に戻る'
  },
  delete_construction_site: {
    modal_header: '削除確認',
    modal_content: '<b>{num}件の箇所が削除されます。</b><br>削除した写真は、復元できません。本当に削除してよろしいでしょうか？',
    btn_not_delete: '削除しない',
    btn_delete: '削除する'
  }
}

export default lang;



// WEBPACK FOOTER //
// ./src/lang/ja/pages/report.js